import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useStyles } from './styles';

interface IProps {
  isRequired: boolean;
}

export const RequiredDisplay = ({ isRequired }: IProps) => {
  const { required, displayTitle } = useStyles();

  if (!isRequired) return null;
  return (
    <div className={required}>
      <FontAwesomeIcon icon={faCheck} />
      <strong className={displayTitle}>Formulário Obrigatório</strong>
    </div>
  );
};
